import type { Processor } from '@app/store/middleware/processorMiddleware.js';
import { toastsRestartTimeout } from '../actions.js';
import { setupTimeout, timeoutMap } from './toasts.js';

export const toastsRestartTimeoutProcessor: Processor<
  typeof toastsRestartTimeout
> = {
  actionCreator: toastsRestartTimeout,
  handle: async ({
    getState,
    action: {
      payload: { id },
    },
  }) => {
    const tm = timeoutMap.get(id);

    if (tm) {
      timeoutMap.delete(id);

      if (tm.timeoutId) {
        clearTimeout(tm.timeoutId);
      }

      const toast = getState().toasts.toasts[id];

      if (toast?.timeout !== undefined) {
        setupTimeout(id, toast.timeout, tm.dispatch);
      }
    }
  },
};
